import React from "react";

const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex h-64 items-center justify-center">
      <div className="h-16 w-16 animate-spin rounded-full border-b-2 border-t-2 border-ctb-blue"></div>
    </div>
  );
};

export default LoadingSpinner;
